export function NotFoundPage(): JSX.Element {
  return <h1>Not Found</h1>
}
